import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ParametrosService } from 'src/app/services/parametros.service';
import { Title } from '@angular/platform-browser';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { VinculoUsuariosService } from 'src/app/incorporated/services/vinculo-usuarios.service';
import { PagamentosService } from 'src/app/services/pagamentos.service';

declare const window: any;

@Component({
  selector: 'app-client-layout',
  templateUrl: './client-layout.component.html',
  styleUrls: ['./client-layout.component.scss']
})
export class ClientLayoutComponent implements OnInit {

  @ViewChild('sidenav') sidenav: any;
  userData: any = {};
  params: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private parametros: ParametrosService,
    private titleService: Title,
    private serverUrlService: ServerUrlService,
    private vinculoUsuario: VinculoUsuariosService,
    private paymentService: PagamentosService
  ) {
    const company = parametros.getParams('APP_COMPANY') || '';
    const title = parametros.getParams('APP_TITLE') || '';
    const logo = parametros.getParams('APP_LOGO') || '';
    const theme = parametros.getParams('APP_THEME') || '';
    const type = parametros.getParams('APP_TYPE') || '';
    const cancel = parametros.getParams('APP_CANCEL') || '';

    this.params = {
      company: company.valor,
      title: title.valor,
      logo: logo.valor,
      theme: theme.valor,
      type: type.valor,
      cancel: cancel.valor
    };

    this.titleService.setTitle(this.params.title);
  }

  ngOnInit() {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    if(userData && userData.integracao_id) {
      this.refreshUserParams(userData.integracao_id, userData)
    }

    if (window.ReactNativeWebView && userData && userData.token) {
      window.ReactNativeWebView.postMessage(JSON.stringify(userData));
    };
  }

  refreshUserParams (userId: number, userData: any) {
    if(!userId) return
    this.vinculoUsuario.getPaciente(userId).subscribe((resp: any) => {
      const formattedUserData = {
        ...userData,
        ocultar_historico: resp.ocultarhistorico
      }

      sessionStorage.setItem('userData', JSON.stringify(formattedUserData))
    })
  }

  onAtualizaClick(hide) {
    if (hide === true) {
      this.sidenav.toggle();
    }
    this.router.navigate(['/' + this.serverUrlService.getName() + '/client/meus-dados']);
  }

  onCadastroClick(hide) {
    if (hide === true) {
      this.sidenav.toggle();
    }
    this.router.navigate(['/' + this.serverUrlService.getName() + '/client/cadastro']);
  }

  onPagamentosClick(hide) {
    if (hide === true) {
      this.sidenav.toggle();
    }
    this.router.navigate(['/' + this.serverUrlService.getName() + '/client/cadastro-asaas']);
  }

  onLoginClick(hide) {
    if (hide === true) {
      this.sidenav.toggle();
    }
    this.router.navigate(['/' + this.serverUrlService.getName() + '/client/login']);
  }

  onMinhaAgendaClick(hide) {
    if (hide === true) {
      this.sidenav.toggle();
    }
    this.router.navigate(['/' + this.serverUrlService.getName() + '/client/meus-agendamentos']);
  }

  onAgendamentoClick(hide) {
    if (hide === true) {
      this.sidenav.toggle();
    }
    let tipo: string;

    if (this.userData) {
      tipo = this.userData.tipo;
    } else {
      tipo = 'client';
    }
    if (tipo === 'admin') {
      this.router.navigate(['/' + this.serverUrlService.getName() + '/client/agendamento']);
    } else {
      this.router.navigate(['/' + this.serverUrlService.getName() + '/client/agendamento']);
    }
  }

  onParametroClick(hide) {
    if (hide === true) {
      this.sidenav.toggle();
    }
    this.router.navigate(['/' + this.serverUrlService.getName() + '/admin/parametros']);
  }

  usuarioLogado() {
    this.userData = JSON.parse(sessionStorage.getItem('userData'));
    return sessionStorage.getItem('userData');
  }

  ocultarHistorico () {
    return this.userData.ocultar_historico
  }

  onLogoutClick() {
    this.sidenav.toggle();
    this.deletePixPayment()

    setTimeout(() => {
      sessionStorage.clear();
      this.authService.logOutUser();
      // window.location.reload();
      const url = window.location.href;
      const n = url.indexOf('/');
      const goTo = url.substring(0, n);
      window.location.href = goTo + this.serverUrlService.getName();
      // this.router.navigate(['/' + this.serverUrlService.getName() + '/admin/parametros']);
    }, 1000);
  }

  deletePixPayment () {
    const paymentInfo = sessionStorage.getItem('pixPayment')
    if(!paymentInfo) return
    const jsonPaymentInfo = JSON.parse(paymentInfo)

    this.paymentService.deleteCharge(jsonPaymentInfo.charge_id).subscribe(() => {})
  }
}
